const UUID_ALIAS_KEY = 'nlims_offline_uuid_aliases';

function getStorage() {
  try {
    if (typeof window === 'undefined' || !window.localStorage) return null;
    return window.localStorage;
  } catch {
    return null;
  }
}

function readAliasMap() {
  const storage = getStorage();
  if (!storage) return {};

  try {
    const raw = storage.getItem(UUID_ALIAS_KEY);
    const parsed = raw ? JSON.parse(raw) : {};
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch {
    return {};
  }
}

function writeAliasMap(map) {
  const storage = getStorage();
  if (!storage) return;

  try {
    storage.setItem(UUID_ALIAS_KEY, JSON.stringify(map));
  } catch {
    // Best-effort only.
  }
}

export function registerUuidAlias(tempUuid, realUuid) {
  const offlineUuid = String(tempUuid ?? '').trim();
  const liveUuid = String(realUuid ?? '').trim();
  if (!offlineUuid || !liveUuid) return null;

  const map = readAliasMap();
  map[offlineUuid] = liveUuid;
  writeAliasMap(map);
  return liveUuid;
}

export function resolveUuidAlias(uuid) {
  const key = String(uuid ?? '').trim();
  if (!key) return null;

  const map = readAliasMap();
  return map[key] ?? null;
}

export function rewriteRequestConfigWithUuidAliases(config = {}) {
  const nextConfig = { ...config };
  const url = String(nextConfig.url ?? '');
  if (!url) return nextConfig;

  const segments = url.split('/').map((segment) => {
    const resolved = resolveUuidAlias(segment);
    return resolved ?? segment;
  });

  nextConfig.url = segments.join('/');
  return nextConfig;
}

